// Multi-Language Configuration for XOFFI2025
// All European Countries + Key International Languages

export const I18N_LANGUAGES = [
  // Primary Languages (Fallback Hierarchy)
  {
    code: 'de',
    name: 'Deutsch',
    shortName: 'DE',
    direction: 'ltr',
    flag: '/media/flags/germany.svg',
    isPrimary: true,
  },
  {
    code: 'en',
    name: 'English',
    shortName: 'EN',
    direction: 'ltr',
    flag: '/media/flags/united-states.svg',
    isPrimary: true,
  },

  // European Union Languages (Official)
  {
    code: 'fr',
    name: 'Français',
    shortName: 'FR',
    direction: 'ltr',
    flag: '/media/flags/france.svg',
  },
  {
    code: 'it',
    name: 'Italiano',
    shortName: 'IT',
    direction: 'ltr',
    flag: '/media/flags/italy.svg',
  },
  {
    code: 'es',
    name: 'Español',
    shortName: 'ES',
    direction: 'ltr',
    flag: '/media/flags/spain.svg',
  },
  {
    code: 'pt',
    name: 'Português',
    shortName: 'PT',
    direction: 'ltr',
    flag: '/media/flags/portugal.svg',
  },
  {
    code: 'nl',
    name: 'Nederlands',
    shortName: 'NL',
    direction: 'ltr',
    flag: '/media/flags/netherlands.svg',
  },
  {
    code: 'pl',
    name: 'Polski',
    shortName: 'PL',
    direction: 'ltr',
    flag: '/media/flags/poland.svg',
  },
  {
    code: 'sv',
    name: 'Svenska',
    shortName: 'SV',
    direction: 'ltr',
    flag: '/media/flags/sweden.svg',
  },
  {
    code: 'da',
    name: 'Dansk',
    shortName: 'DA',
    direction: 'ltr',
    flag: '/media/flags/denmark.svg',
  },
  {
    code: 'no',
    name: 'Norsk',
    shortName: 'NO',
    direction: 'ltr',
    flag: '/media/flags/norway.svg',
  },
  {
    code: 'fi',
    name: 'Suomi',
    shortName: 'FI',
    direction: 'ltr',
    flag: '/media/flags/finland.svg',
  },
  {
    code: 'cs',
    name: 'Čeština',
    shortName: 'CS',
    direction: 'ltr',
    flag: '/media/flags/czech-republic.svg',
  },
  {
    code: 'sk',
    name: 'Slovenčina',
    shortName: 'SK',
    direction: 'ltr',
    flag: '/media/flags/slovakia.svg',
  },
  {
    code: 'hu',
    name: 'Magyar',
    shortName: 'HU',
    direction: 'ltr',
    flag: '/media/flags/hungary.svg',
  },
  {
    code: 'ro',
    name: 'Română',
    shortName: 'RO',
    direction: 'ltr',
    flag: '/media/flags/romania.svg',
  },
  {
    code: 'bg',
    name: 'Български',
    shortName: 'BG',
    direction: 'ltr',
    flag: '/media/flags/bulgaria.svg',
  },
  {
    code: 'hr',
    name: 'Hrvatski',
    shortName: 'HR',
    direction: 'ltr',
    flag: '/media/flags/croatia.svg',
  },
  {
    code: 'sl',
    name: 'Slovenščina',
    shortName: 'SL',
    direction: 'ltr',
    flag: '/media/flags/slovenia.svg',
  },
  {
    code: 'lt',
    name: 'Lietuvių',
    shortName: 'LT',
    direction: 'ltr',
    flag: '/media/flags/lithuania.svg',
  },
  {
    code: 'lv',
    name: 'Latviešu',
    shortName: 'LV',
    direction: 'ltr',
    flag: '/media/flags/latvia.svg',
  },
  {
    code: 'et',
    name: 'Eesti',
    shortName: 'ET',
    direction: 'ltr',
    flag: '/media/flags/estonia.svg',
  },
  {
    code: 'el',
    name: 'Ελληνικά',
    shortName: 'EL',
    direction: 'ltr',
    flag: '/media/flags/greece.svg',
  },
  {
    code: 'mt',
    name: 'Malti',
    shortName: 'MT',
    direction: 'ltr',
    flag: '/media/flags/malta.svg',
  },
  {
    code: 'ga',
    name: 'Gaeilge',
    shortName: 'GA',
    direction: 'ltr',
    flag: '/media/flags/ireland.svg',
  },

  // Additional European Languages (Non-EU)
  {
    code: 'ru',
    name: 'Русский',
    shortName: 'RU',
    direction: 'ltr',
    flag: '/media/flags/russia.svg',
  },
  {
    code: 'uk',
    name: 'Українська',
    shortName: 'UK',
    direction: 'ltr',
    flag: '/media/flags/ukraine.svg',
  },
  {
    code: 'tr',
    name: 'Türkçe',
    shortName: 'TR',
    direction: 'ltr',
    flag: '/media/flags/turkey.svg',
  },
  {
    code: 'sr',
    name: 'Српски',
    shortName: 'SR',
    direction: 'ltr',
    flag: '/media/flags/serbia.svg',
  },
  {
    code: 'mk',
    name: 'Македонски',
    shortName: 'MK',
    direction: 'ltr',
    flag: '/media/flags/republic-of-macedonia.svg',
  },
  {
    code: 'al',
    name: 'Shqip',
    shortName: 'AL',
    direction: 'ltr',
    flag: '/media/flags/albania.svg',
  },
  {
    code: 'is',
    name: 'Íslenska',
    shortName: 'IS',
    direction: 'ltr',
    flag: '/media/flags/iceland.svg',
  },

  // Additional Global Languages
  {
    code: 'ar',
    name: 'العربية',
    shortName: 'AR',
    direction: 'rtl',
    flag: '/media/flags/saudi-arabia.svg',
  },
  {
    code: 'zh',
    name: '中文',
    shortName: 'ZH',
    direction: 'ltr',
    flag: '/media/flags/china.svg',
  },
  {
    code: 'ja',
    name: '日本語',
    shortName: 'JA',
    direction: 'ltr',
    flag: '/media/flags/japan.svg',
  },
];

// Language Configuration
export const I18N_CONFIG = {
  // Fallback hierarchy: Selected Language -> German -> English
  fallbackLanguage: 'de',
  ultimateFallback: 'en',
  
  // Default language for new organizations
  defaultLanguage: 'de',
  
  // Auto-translation settings
  autoTranslate: {
    enabled: true,
    threshold: 0.7, // Minimum translation completeness before auto-translate
    batchSize: 50,  // Keys per batch
  },
  
  // Cache settings
  cache: {
    enabled: true,
    ttl: 3600000, // 1 hour in milliseconds
  },
  
  // Namespace configuration
  namespaces: {
    default: 'common',
    available: ['common', 'navigation', 'forms', 'errors', 'dashboard', 'admin'],
  }
};
